<template lang="html">

    <section class="banner-curiosidades" ref="banner" @mouseover="playbackground" @mouseleave="pausebackground" v-if="!!curiosidades">

        <div class="container">



            <div class="acceso-curiosidades-container row-center">
                <div class="acceso-curiosidades row-end ais">
                    <div class="left row-start">
                        <h3>{{curiosidades[0].name}}</h3>
                    </div>
                    <div class="right column-start -enviar-white">
                        <h3>{{$t('bannerCuriosidades.descubrelo')}}</h3>
                    </div>
                </div>

                <router-link :to="$t('enlaces.metelefiesta')+$t('enlaces.curiosidades')" class="enlace-cover"></router-link>

            </div>
        </div>


    </section>

</template>

<script lang="js">

     import { TimelineLite } from 'gsap'


     import {mapGetters} from 'vuex';
 
     export default  {
       name: 'banner-newsletter',
       mounted(){
        const { banner } = this.$refs;
        this.timeline = new TimelineLite({paused:true}) ;
        this.timeline.to(banner, 10, {'background-position':'50% 0%'}) 
       },
       data(){
           return{
                timeline : ''
           }
       },
       computed:{
        ...mapGetters({
            curiosidades : 'getCuriosidades'
        })
        },
       methods : {
           playbackground(){
               this.timeline.play();
           },
           pausebackground(){
               this.timeline.pause();
           }
       }
     }
   </script>
<style scoped lang="scss">
 
   </style>


// WEBPACK FOOTER //
// src/components/parts/banner-curiosidades.vue